import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["data-test-id"]
const _hoisted_2 = ["src", "title", "height", "width"]

import { DotLottieVue } from '@lottiefiles/dotlottie-vue';
import loadingData from '@/assets/animated-icons/Loading_spinner_blue.json';
import { ref } from 'vue';
import { ComponentFields, ComponentRendering, Field } from '@sitecore-jss/sitecore-jss-vue';
import { usePageStore } from '@/store';
import { useRoute } from 'vue-router';
import { stringify } from 'querystring';


export default /*@__PURE__*/_defineComponent({
  __name: 'IFrame',
  props: {
    rendering: {},
    fields: {}
  },
  setup(__props: any) {

const props = __props;

// Forward query to iframe
const route = useRoute();
const queryString = stringify((route?.query as Record<string, string>) ?? {});
const iframeUrl = (props.fields.src as Field<string>)?.value;
const embeddedPage = ref<string>(`${iframeUrl}${iframeUrl?.includes('?') ? '&' : '?'}${queryString}`);

const loadingIconData = loadingData as any;
const embeddedPageTitle = ref<string>((props.fields.title as Field<string>)?.value);
const innerClass = ref<string>((props.fields.innerClass as Field<string>)?.value);
const outerClass = ref<string>((props.fields.outerClass as Field<string>)?.value);
const height = ref<number>((props.fields.height as Field<number>)?.value);
const width = ref<number>((props.fields.width as Field<number>)?.value);
const iframeLoaded = ref(false);

const outerClassRendering = props.rendering?.params?.Styles;
const inlineStyle = props.rendering?.params?.inlineStyle;
const dataTestId = usePageStore().dataTestId(props.rendering);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([outerClass.value, _unref(outerClassRendering)]),
    style: _normalizeStyle(_unref(inlineStyle)),
    "data-test-id": _unref(dataTestId)
  }, [
    (_unref(iframeUrl))
      ? _withDirectives((_openBlock(), _createElementBlock("iframe", {
          key: 0,
          src: embeddedPage.value,
          title: embeddedPageTitle.value,
          class: _normalizeClass(innerClass.value),
          height: height.value,
          width: width.value,
          onLoadstart: _cache[0] || (_cache[0] = ($event: any) => (iframeLoaded.value = false)),
          onLoad: _cache[1] || (_cache[1] = ($event: any) => (iframeLoaded.value = true))
        }, null, 42, _hoisted_2)), [
          [_vShow, iframeLoaded.value]
        ])
      : _createCommentVNode("", true),
    (!iframeLoaded.value && _unref(iframeUrl))
      ? (_openBlock(), _createBlock(_unref(DotLottieVue), {
          key: 1,
          autoplay: "",
          class: "absolute top-[50%] left-[50%] translate-y-[-50%] translate-x-[-50%]",
          style: {"width":"80px"},
          loop: "",
          data: _unref(loadingIconData)
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}
}

})